import { ReactNode, useEffect } from 'react'

import { useInViewport } from 'src/hooks/useInViewport'

export interface TabData {
  label: ReactNode
  value: string
  disabled?: boolean
  // eslint-disable-next-line react/no-unused-prop-types
  path?: string
}

interface TabProps extends TabData {
  isActive: boolean
  onClick: (newValue: string) => void
}

const Tab = ({ isActive, label, onClick, value, disabled }: TabProps) => {
  const { scrollIntoView, ref: buttonRef } = useInViewport()

  useEffect(() => {
    if (isActive) {
      scrollIntoView()
    }
  }, [isActive, scrollIntoView])

  return (
    <button
      ref={buttonRef}
      disabled={disabled}
      className={`text-base font-bold inline-flex items-center justify-center box-border bg-transparent outline-current outline-none outline-0 m-0 cursor-pointer select-none align-middle appearance-none no-underline font-body uppercase max-w-[360px] min-w-[90px] relative min-h-[48px] shrink-0 py-3 px-4 overflow-hidden whitespace-normal text-center flex-direction-column ${
        isActive
          ? 'text-forestDeep border-b-2 border-b-forestDeep pb-2.5'
          : 'text-forestDeep/80 border-0'
      } ${disabled ? 'text-iron! pointer-events-none' : ''}`}
      onClick={() => onClick(value)}
      role='tab'
      aria-selected={isActive}
      type='button'
    >
      {label}
    </button>
  )
}
interface TabsProps {
  activeTab: string
  ariaLabel: string
  className?: string
  onChange: (newValue: string) => void
  tabs: TabData[]
}

export const Tabs = ({
  activeTab,
  ariaLabel,
  className = '',
  onChange,
  tabs
}: TabsProps) => {
  return (
    <div
      aria-label={ariaLabel}
      className={`w-full overflow-x-auto no-scrollbar min-h-[48px] ${className}`}
    >
      <div className='inline-block relative flex-auto whitespace-nowrap'>
        <div className='flex'>
          {tabs.map(tab => (
            <Tab
              key={tab.value}
              isActive={activeTab === tab.value}
              label={tab.label}
              value={tab.value}
              onClick={onChange}
              disabled={tab.disabled}
              path={tab.path}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
